import { useDispatch, useSelector } from "react-redux";
import {
  pushCouponCodeToCart,
  pushItemsToCart,
} from "store/actions/cart.action";
import useCart from "hooks/useCart";

//Handles add/remove/delete an item from cart
function useCartItem(item) {
  const vendingMachineItems = useSelector(
    (state) => state.vmStockReducer.items
  );

  const vmCategoriesAvailable = useSelector(
    (state) => state.vmStockReducer.categories
  );
  const { currentCartItems } = useCart();
  const dispatch = useDispatch();

  //Store next items in redux.
  const dispatchItemsToCart = function (nextItemsInCart) {
    dispatch(pushItemsToCart(nextItemsInCart));
  };

  //Retreive current item from cart.
  const currentItemQuantityInCart = currentCartItems
    .filter((element) => {
      return item.multipleStk
        ? element.item.iUID === item.iUID
        : element.item.sid === item.sid;
    })
    .reduce((acc, item) => {
      return acc + item.quantity;
    }, 0);

  //Calculates category name.
  const itemCategoryName = vmCategoriesAvailable.reduce(
    (accumulator, category) => {
      if (item.catID[0] === category.catID) {
        return category.name;
      }

      return accumulator;
    },
    ""
  );

  const itemQuantity = currentItemQuantityInCart || 0;

  const handleItemInCart = function (difference = 0) {
    //reset coupon code.
    dispatch(pushCouponCodeToCart(null));
    //Adds item to the cart.
    if (difference === 0) {
      //If no stock is available, do not allow to add item.
      if (!item.stk) {
        return;
      }
      if (item.multipleStk) {
        let firstProductFoundInVM = vendingMachineItems.find(
          (ele) => ele.iUID === item.iUID && ele.stk
        );

        return dispatchItemsToCart([
          ...currentCartItems,
          { item: firstProductFoundInVM, quantity: 1, discount: 0 },
        ]);
      }
      return dispatchItemsToCart([
        ...currentCartItems,
        { item, quantity: 1, discount: 0 },
      ]);
    }

    if (item.multipleStk) {
      let currentItemsInVM = vendingMachineItems.filter(
        (ele) => ele.iUID === item.iUID && ele.stk
      );
      let currentItemsInCart = currentCartItems.filter(
        (ele) => ele.item.iUID === item.iUID
      );

      let nextAvailableItemForCart = null;
      currentItemsInVM.forEach((item) => {
        if (
          !~currentCartItems.findIndex((ele) => ele.item.sid === item.sid) &&
          !nextAvailableItemForCart
        ) {
          nextAvailableItemForCart = item;
        }
      });

      let lastElementInCart = null;
      currentCartItems.forEach((ele) => {
        if (ele.item.iUID === item.iUID) {
          lastElementInCart = ele;
        }
      });
      const nextElementQuantity = lastElementInCart.quantity + difference;
      //Remove last cart item
      if (nextElementQuantity === 0) {
        return dispatchItemsToCart(
          currentCartItems.filter((ele) => {
            return ele.item.sid !== lastElementInCart.item.sid;
          })
        );
      }
      //Disable addition of quantity
      if (
        currentItemsInVM.length === currentItemsInCart.length &&
        nextElementQuantity === lastElementInCart.item.stk + 1
      ) {
        return;
      }

      //Increase quantity of last cart item
      if (nextElementQuantity <= lastElementInCart.item.stk) {
        return dispatchItemsToCart(
          currentCartItems.map((ele) => {
            if (ele.item.sid === lastElementInCart.item.sid) {
              return { ...ele, quantity: nextElementQuantity };
            }
            return ele;
          })
        );
      }

      //push new cart item.
      return dispatchItemsToCart([
        ...currentCartItems,
        { item: nextAvailableItemForCart, quantity: 1, discount: 0 },
      ]);
    }

    let deleteIndex = -1;

    //Increase or decrease Item quantity.
    let nextItemsInCart = currentCartItems.map(function (element, index) {
      const nextElementQuantity = element.quantity + difference;

      //Only allow the quantity to add upto the stock available.
      if (element.item.sid === item.sid && nextElementQuantity <= item.stk) {
        //If next quantity of the item is 0, remove it from the cart automatically.
        if (nextElementQuantity === 0) {
          deleteIndex = index;
        }
        return { ...element, quantity: nextElementQuantity };
      }

      return element;
    });

    //If quantity is 0, remove the item.
    if (~deleteIndex) {
      nextItemsInCart = currentCartItems.filter(
        (element, index) => index !== deleteIndex
      );
    }

    return dispatchItemsToCart(nextItemsInCart);
  };

  //Removes an item from cart.
  const deleteItemFromCart = function () {
    let nextItemsInCart = currentCartItems.filter(
      (element) => element.item.sid !== item.sid
    );

    return dispatchItemsToCart(nextItemsInCart);
  };

  const updateDiscountOfItem = function (itemId, discount) {
    let nextItemsInCart = currentCartItems.map((itemObject) => {
      if (itemObject.item.sid === itemId) {
        return { ...itemObject, discount };
      }
      return itemObject;
    });

    return dispatchItemsToCart(nextItemsInCart);
  };

  return {
    itemQuantity,
    handleItemInCart,
    itemCategoryName,
    deleteItemFromCart,
    updateDiscountOfItem,
  };
}

export default useCartItem;
